(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionnaireTemplateSectionFullController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', 'notificationService', 'govNotificationDelay', 'oddQuestionnaireTemplateService',
        'oddSurveyQuestionnaireTemplateService'];

    function Controller($scope, $timeout, $state, notificationService, govNotificationDelay, oddQuestionnaireTemplateService,
                        oddSurveyQuestionnaireTemplateService) {

        $scope.ctrlCtxt = {};

        // Create Or Update
        $scope.createOrUpdate = function () {
            if ($scope.form.$invalid) {
                $scope.ctrlCtxt.showSubmitError      = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.isFormInvalidMsgShow = false;
            $scope.ctrlCtxt.showSubmitError      = false;
            $scope.ctrlCtxt.isLoading            = true;

            // Create Section
            if (!$scope.boxModel.ODDSectionID) {
                var sectionCreated;
                var urlAfterSectionCreated;
                if ($scope.boxContext && $scope.boxContext.campaign && $scope.boxContext.campaign._isSurvey) {
                    sectionCreated         = oddSurveyQuestionnaireTemplateService
                        .createSection($scope.boxModel.ODDBusinessUnitID,
                            $scope.boxModel.ODDQuestionnaireID,
                            $scope.boxModel);
                    urlAfterSectionCreated = 'odd.surveyCampaignEdit.section';

                } else {
                    sectionCreated         = oddQuestionnaireTemplateService
                        .createSection($scope.boxModel.ODDBusinessUnitID,
                            $scope.boxModel.ODDQuestionnaireID,
                            $scope.boxModel);
                    urlAfterSectionCreated = 'odd.questionnaireTemplatesEdit.questionnaire.section';

                }

                sectionCreated.then(function (createdSection) {
                        notificationService.notify('The Section was created');
                        $scope.form.$setPristine();
                        $state.go(urlAfterSectionCreated, {
                            ODDQuestionnaireID: createdSection.ODDQuestionnaireID,
                            ODDSectionID: createdSection.ODDSectionID
                        });
                    })
                    .finally(function () {
                        $scope.ctrlCtxt.isLoading = false;
                    });
            } else {
                var sectionUpdated;
                if ($scope.boxContext && $scope.boxContext.campaign && $scope.boxContext.campaign._isSurvey) {
                    sectionUpdated = oddSurveyQuestionnaireTemplateService
                        .updateSection($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDQuestionnaireID, $scope.boxModel);
                }
                else {
                    sectionUpdated = oddQuestionnaireTemplateService
                        .updateSection($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDQuestionnaireID, $scope.boxModel);
                }

                sectionUpdated.then(function (updSection) {
                        $scope.boxModel = updSection;
                        notificationService.notify('Your changes have been saved');
                        $scope.form.$setPristine();
                    })
                    .finally(function () {
                        $scope.ctrlCtxt.isLoading = false;
                    });
            }
        };

        // Delete Section
        $scope.deleteSection = function () {
            $scope.ctrlCtxt.isLoading = true;
            var sectionDeleted;
            var urlAfterSectionDeleted;

            if ($scope.boxContext && $scope.boxContext.campaign && $scope.boxContext.campaign._isSurvey) {
                sectionDeleted         = oddSurveyQuestionnaireTemplateService
                    .deleteSection($scope.boxModel.ODDBusinessUnitID,
                        $scope.boxModel.ODDQuestionnaireID,
                        $scope.boxModel.ODDSectionID);
                urlAfterSectionDeleted = 'odd.surveyCampaignEdit';

            } else {
                sectionDeleted         = oddQuestionnaireTemplateService
                    .deleteSection($scope.boxModel.ODDBusinessUnitID,
                        $scope.boxModel.ODDQuestionnaireID,
                        $scope.boxModel.ODDSectionID);
                urlAfterSectionDeleted = 'odd.questionnaireTemplatesEdit.questionnaire';
            }
            sectionDeleted.then(function () {
                    notificationService.notify('Section has been deleted');
                    $state.go(urlAfterSectionDeleted, {}, {reload: true});
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        };

        // showIsInCampaignErrorMsg
        $scope.showIsInCampaignErrorMsg = function () {
            $scope.ctrlCtxt.isInCampaignMsgShow = true;

            $timeout(function () {
                $scope.ctrlCtxt.isInCampaignMsgShow = false;
            }, govNotificationDelay);
        };

        // When the condition choice is selected
        $scope.onConditionChoiceSelected = function (question, choice) {
            $scope.boxModel.ConditionalODDQuestionID       = question.ODDQuestionID;
            $scope.boxModel.ConditionalODDQuestion         = question;
            $scope.boxModel.ConditionalODDQuestionChoiceID = choice.ODDQuestionChoiceID;
            $scope.boxModel.ConditionalODDQuestionChoice   = choice;
            $scope.form.$setDirty();
        };

        // When the condition is removed
        $scope.onConditionRemoved = function () {
            delete $scope.boxModel.ConditionalODDQuestionID;
            delete $scope.boxModel.ConditionalODDQuestion;
            delete $scope.boxModel.ConditionalODDQuestionChoiceID;
            delete $scope.boxModel.ConditionalODDQuestionChoice;
            $scope.form.$setDirty();
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };

        // Cancel
        $scope.cancel = function () {
            $state.go($state.$current.parent.name, {reload: true});
        };
    }

})();